<template>
  <div>
    <span class="uppercase font-medium text-sm text-muted block ml-2 tracking-wide">
      Categories
    </span>
    <ul class="mt-4">
      <li class="pb-1">
        <BaseButton
          :ghost="$route.query.filter && +$route.query.filter.has_category > 0"
          small
          :primary="!$route.query.filter || !$route.query.filter.has_category"
          :disabled="disabled"
          class="block w-full text-left"
          @click="setFilter('has_category', null)"
        >
          All
        </BaseButton>
      </li>
      <li v-for="productCategory in productCategories" :key="productCategory.id" class="py-1">
        <BaseButton
          :ghost="
            $route.query.filter === undefined ||
            $route.query.filter.has_category === undefined ||
            +$route.query.filter.has_category !== productCategory.id
          "
          small
          :primary="
            $route.query.filter &&
            $route.query.filter.has_category &&
            $route.query.filter.has_category &&
            +$route.query.filter.has_category === productCategory.id
          "
          :disabled="disabled"
          class="block w-full text-left"
          @click="setFilter('has_category', productCategory.id)"
        >
          {{ productCategory.name }}
        </BaseButton>
      </li>
    </ul>
  </div>
</template>

<script>
import { omit } from 'lodash-es';
import { mapState } from 'vuex';

export default {
  name: 'SidebarFilters',
  props: {
    disabled: Boolean,
  },
  computed: {
    ...mapState('entities', {
      productCategoriesById: (state) => state.productCategories.byId,
    }),
    productCategories() {
      return Object.keys(this.productCategoriesById).map(
        (productCategoryId) => this.productCategoriesById[productCategoryId]
      );
    },
  },
  methods: {
    setFilter(name, value) {
      const { filter = {}, ...restQuery } = this.$route.query;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...JSON.parse(JSON.stringify(restQuery)),
          filter: {
            ...JSON.parse(JSON.stringify(omit(filter, [name]))),
            ...(value ? { [name]: value } : {}),
          },
          page: 1,
        },
      });
    },
  },
};
</script>
